import { useUserStore } from "@/stores/userStore";
import { UserCard } from "@/components/users/UserCard";
import { useGetUser } from "@/hooks/queryHooks/userHooks";

export const ProfilePage = () => {
  const user = useUserStore((s) => s.user);
  const { data: userData } = useGetUser(user?.id ?? "");

  if (!userData) return null;

  return (
    <div className="flex flex-col flex-grow">
      <div className="max-w-lg mx-auto">
        <UserCard user={userData} />
      </div>
    </div>
  );
};
